import {
  Form,
  Input,
  Checkbox,
  Select,
  Divider,
  Radio,
  InputNumber,
} from "antd";
import ContentPadding from "../ContentConfig/ContentPadding";
import FormCustomIDField from "../ContentConfig/FormCustomIDField";
import TrimmedInput from "../FormCommonField/FormTrimmedInput";
import { ColorPickerFormItem } from "../Image/ImageConf";
import { DEF_FONTS } from "../constanst";

export default ({ node }) => {
  const defalutLabel = node?.data?.label || ""
  return (
    <>
      <Form.Item
        label="Label"
        name="label"
        rules={[{ required: true, max: 256 }]}
      >
        <TrimmedInput/>
      </Form.Item>
      <Form.Item name="hideLabel" valuePropName="checked">
        <Checkbox>Hide Label</Checkbox>
      </Form.Item>
      <FormCustomIDField />
      <Form.Item name="required" valuePropName="checked">
        <Checkbox>Required</Checkbox>
      </Form.Item>
      <Form.Item name="ratingLevel" label="Rating score">
        <Select
          options={Array(9)
            .fill(null)
            .map((_, index) => {
              return { label: `${index + 2}`, value: index + 2 };
            })}
        />
      </Form.Item>
      <Form.Item label="Left label" name="lowRatingLabel">
        <Input />
      </Form.Item>
      <Form.Item label="Right label" name="highRatingLabel">
        <Input />
      </Form.Item>
      {/* Label settings group */}
      <div>
        <Form.Item
          label="Label horizon alignment"
          name="labelHorizonAlignment"
          initialValue={"start"}
        >
          <Radio.Group buttonStyle="solid">
            <Radio.Button value="start">Left</Radio.Button>
            <Radio.Button value="center">Center</Radio.Button>
            <Radio.Button value="end">Right</Radio.Button>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label="Label font size"
          name="labelFontSize"
          initialValue={14}
        >
          <InputNumber min={0} max={100} style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item
          label="Label default font"
          name="labelDefaultFont"
          initialValue={"arial"}
        >
          <Select showSearch options={DEF_FONTS} />
        </Form.Item>
        <ColorPickerFormItem
          label="Label font color"
          name="labelFontColor"
          color={node?.data?.labelFontColor || { r: 0, g: 0, b: 0, a: 1 }}
        />
      </div>
      <Form.Item label="Rating Style" name="ratingStyle">
        <Radio.Group buttonStyle="solid">
          <Radio.Button value="number">Number</Radio.Button>
          <Radio.Button value="star">Star</Radio.Button>
        </Radio.Group>
      </Form.Item>
      <strong>Style</strong>
      <Divider style={{ margin: "12px 0" }} />
      <ContentPadding />
    </>
  );
};
